import { render } from "./ExOrderForm.vue?vue&type=template&id=7a080cd2"
import script from "./ExOrderForm.vue?vue&type=script&lang=js"
export * from "./ExOrderForm.vue?vue&type=script&lang=js"

import "./ExOrderForm.vue?vue&type=style&index=0&id=7a080cd2&lang=scss"

import exportComponent from "F:\\my_work_space\\cmall-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__